import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Dialog from 'material-ui/Dialog';

import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../../../../../../components/buttons';
import { renderTextField } from '../../../../../../../../../components/reduxFields';
import SmallLoader from '../../../../../../../../../img/small-loader.gif';
import { checkFieldExistence, clearFieldErrorArray } from '../../../../../../../../AppConfig/actions';
import { displayCustomError } from '../../../../../../../../../actions/utilAction';
import { MODULE } from '../../../../../../DataCollection/BehaviorReductiom/Locations/constants/ApiConstants';
import { saveLocations } from '../../../../../../DataCollection/BehaviorReductiom/Locations/actions/locationsActions';



const validate = (values) => {
    const errors = {};
    if (!values.locationName) {
        errors.locationName = 'Please enter location name';
    }
    return errors;
};

class AddLocationsDataModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: true,
        };
        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleNewRequest = this.handleNewRequest.bind(this);
    }

    handleOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        if (this.state.open) {
            this.setState({ open: false });
            this.props.closeDialog();
        }
    };

    componentWillReceiveProps(nextProps) {
        let self = this;
        document.onkeydown = function (evt) {
            evt = evt || window.event;
            if (evt.keyCode === 27) {
                self.handleClose();
            }
        };
    }

    onSubmitHandler(formProps) {
        if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
            return null;
        }

        let postData = {
            "id": 0,
            "patientId": this.props.patientId,
            "locationName": formProps.locationName,
            "description": null,
            "isActive": true,
            "totalRecords": 0,
            "actionName": "COLLECT DATA"
        }

        this.props.saveLocations(postData, this.props.patientId);
        this.props.closeDialog();
    }

    checkFieldDataExistence = (input, value, labelName) => {
        if (value.length > 0) {
            let postData = {
                'labelName': labelName,
                'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
                'value': value,
                'colmnName': input.target.name.toUpperCase(),
                'id': this.props.behaviorId || 0,
                'patientId': this.props.patientId ? parseInt(this.props.patientId) : 0,
            };
            this.props.checkFieldExistence(postData);
        }
    };

    handleNewRequest = (input, selectedRecord) => {
        input.onChange(selectedRecord.value);
    }

    renderLoading() {
        return (
            <div>
                {this.props.loading ?
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                    : null}
            </div>
        );
    }


    render() {
        const { handleSubmit } = this.props;
        let submitButton = this.props.loading ?
            <SubmitButtonModalDisabled label="Loading" /> :
            <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
        const actions = [
            <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
            submitButton,
        ];
        return (
            <div>
                <Dialog
                    className="custom_modal"
                    title='Add Location'
                    modal={false}
                    open={this.state.open}
                    actions={actions}
                    autoScrollBodyContent={true}
                >
                    {this.renderLoading()}
                    <div className="row">
                        <div className="col-sm-12">
                            <form className="readmin-form custom_form">
                                <div className="row">
                                    <div className='col-sm-12 require'>
                                        <Field
                                            name="locationName"
                                            label="Location Name"
                                            type="text"
                                            onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Location name')}
                                            customError={displayCustomError('LOCATIONNAME', this.props.fieldError)}
                                            maxLength="250"
                                            component={renderTextField}
                                            autoFocus="true"
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </Dialog >
            </div >
        );
    }
}

const mapStateToProps = (state) => {
    return {

    };
};

AddLocationsDataModal = reduxForm({
    form: 'AddConsequencesDataModalForm', // a unique identifier for this form
    validate,
})(AddLocationsDataModal);

export default connect(mapStateToProps, { saveLocations, checkFieldExistence, clearFieldErrorArray })(AddLocationsDataModal);



// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/components/RecordABCData/Modals/AddLocationsModal.js